export default __webpack_public_path__ + "static/mintme-4-0a33c0d2689a82d9a7670ad1fd7459e2.svg";